var render = function render(){var _vm=this,_c=_vm._self._c;return _c('grey-button',{staticClass:"pl-3 pr-3",staticStyle:{"cursor":"pointer","gap":"4px"},attrs:{"data-toggle":"modal","data-target":"#helpcenterModal"}},[_c('i',{staticClass:"fal fa-comment icon-whatsapp"}),_vm._v(" "),_c('span',[_vm._v("Fragen?")])])
}
var staticRenderFns = []

export { render, staticRenderFns }